<template>
<div class="chapter">
<div class="inner_page">
<div class="wrapa"><a id="f0006-01"><div class="imgblock W98"><img alt="Image" src="images/f0006-01.jpg"/></div></a></div><a id="f0006-01">
<p class="center">“It’s easier to put on slippers than to carpet the world.”</p>
<p class="att1">—Al Franken</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pref01.vue?1da4c16a